<template>
    <form id="msform" method="post">
        <input type="hidden" name="route" value="account/register" />

        <fieldset>
            <h2 class="fs-title">Dados de Acesso</h2>
            <div class="form-group">
                <label
                    >Nome do Usuário Principal
                    <span class="text-danger">*</span></label
                >
                <input
                    type="text"
                    class="name form-control"
                    :class="{ 'is-invalid': errors.name }"
                    name="name"
                    placeholder="João de Souza"
                    autocomplete="off"
                    v-model="registerData.name"
                    required=""
                />
                <div v-if="errors.name" class="invalid-feedback">
                    <strong>{{ errors.name.join(", ") }}</strong>
                </div>
            </div>
            <div class="form-group">
                <label>E-mail <span class="text-danger">*</span></label>
                <input
                    type="email"
                    class="user-email form-control"
                    :class="{ 'is-invalid': errors.email }"
                    placeholder="email@email.com"
                    autocomplete="off"
                    @blur="checkEmail"
                    @paste="handlePaste"
                    v-model="registerData.email"
                    required=""
                />
                <div v-if="errors.email" class="invalid-feedback">
                    <strong>{{ errors.email.join(", ") }}</strong>
                </div>
            </div>
            <div class="form-group">
                <label
                    >Repita o E-mail <span class="text-danger">*</span></label
                >
                <input
                    type="email"
                    name="email"
                    @paste="handlePaste"
                    class="user-email2 form-control"
                    :class="{ 'is-invalid': errors.email_confirmation }"
                    placeholder="email@email.com"
                    autocomplete="off"
                    required=""
                    v-model="registerData.email_confirmation"
                />
                <div v-if="errors.email_confirmation" class="invalid-feedback">
                    <strong>{{ errors.email_confirmation.join(", ") }}</strong>
                </div>
            </div>
            <div class="form-group">
                <label>Celular <span class="text-danger">*</span></label>
                <input
                    type="tel"
                    class="form-control"
                    placeholder="(00) 0000-0000"
                    autocomplete="off"
                    @keydown="restrictInput"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    required=""
                    :class="{ 'is-invalid': errors.user_cell }"
                    v-model="registerData.user_cell"
                />
                <div v-if="errors.user_cell" class="invalid-feedback">
                    <strong>{{ errors.user_cell.join(", ") }}</strong>
                </div>
            </div>
            <div class="form-group">
                <label>Senha <span class="text-danger">*</span></label>
                <input
                    type="password"
                    class="password form-control"
                    placeholder="******"
                    :class="{ 'is-invalid': errors.password }"
                    v-model="registerData.password"
                    autocomplete="new-password"
                />
                <div v-if="errors.password" class="invalid-feedback">
                    <strong>{{ errors.password.join(", ") }}</strong>
                </div>
            </div>
            <div class="form-group">
                <label>Repita a Senha <span class="text-danger">*</span></label>
                <input
                    type="password"
                    class="password2 form-control"
                    name="user_password"
                    placeholder="******"
                    :class="{ 'is-invalid': errors.password_confirmation }"
                    v-model="registerData.password_confirmation"
                    autocomplete="new-password"
                />
                <div
                    v-if="errors.password_confirmation"
                    class="invalid-feedback"
                >
                    <strong>
                        {{ errors.password_confirmation.join(", ") }}
                    </strong>
                </div>
            </div>
            <div class="form-group">
                <b-form-checkbox
                    v-model="registerData.termos"
                    :class="{ 'is-invalid': errors.termos }"
                    name="termos"
                    value="1"
                    unchecked-value="0"
                >
                    <p>
                        Declaro que li e concordo com os
                        <a
                            href="https://www.econsulte.com/termos"
                            target="_blank"
                            >Termos de uso</a
                        >
                        e
                        <a
                            href="https://www.econsulte.com/privacidade"
                            target="_blank"
                            >Política de Privacidade</a
                        >.
                    </p>
                </b-form-checkbox>
                <div v-if="errors.termos" class="invalid-feedback">
                    <strong>{{ errors.termos.join(", ") }}</strong>
                </div>
            </div>
            <button
                type="button"
                class="btn btn-lg btn-block btn-success next action-button btn-step-1 text-uppercase"
                data-fildset="1"
                @click="submit"
                :disabled="isFormIncomplete || isLoading"
            >
                <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm"
                ></span>
                <span v-else>Cadastrar</span>
            </button>
        </fieldset>
    </form>
</template>
<script>
import { z } from "zod";
import api from "../../../api";
import { TheMask } from "vue-the-mask";
const schema = z
    .object({
        name: z
            .string({
                message: "Informe o nome completo",
            })
            .trim()
            .refine((val) => val.split(" ").length > 1, {
                message: "Informe seu nome completo",
            }),
        email: z.string().email({ message: "Informe um e-mail válido" }),
        termos: z.string().refine((val) => val === "1", {
            message: "Você precisa concordar com os termos",
        }),
        email_confirmation: z
            .string()
            .email({ message: "Informe um e-mail válido" }),

        password: z
            .string()
            .min(6, { message: "A senha deve ter pelo menos 6 caracteres" }),

        password_confirmation: z.string().min(6, {
            message: "A confirmação de senha deve ter pelo menos 6 caracteres",
        }),
        user_cell: z.string().min(10, {
            message: "O número de celular deve ter pelo menos 10 dígitos",
        }),
    })
    .refine((data) => data.password === data.password_confirmation, {
        message: "As senhas não conferem",
        path: ["password_confirmation"],
    })
    .refine((data) => data.email === data.email_confirmation, {
        message: "Os e-mails não conferem",
        path: ["email_confirmation"],
    });

export default {
    components: {
        TheMask,
    },
    computed: {
        isFormIncomplete() {
            return Object.values(this.registerData).some(
                (value) => value.length == 0
            );
        },
    },
    watch: {
        registerData: {
            async handler() {
                if (this.shouldRevalidate) {
                    await this.validate();
                }
            },
            deep: true,
            immediate: true,
        },
    },

    data() {
        return {
            isLoading: false,
            shouldRevalidate: false,
            registerData: {
                name: "",
                email: "",
                email_confirmation: "",
                password: "",
                password_confirmation: "",
                user_cell: "",
                termos: "",
            },
            errors: {},
        };
    },
    methods: {
        async checkEmail() {
            const valiadtion = await z
                .string()
                .email()
                .safeParseAsync(this.registerData.email);
            if (!valiadtion.success) {
                return;
            }
            try {
                const response = await api.post("../account/checkEmail", {
                    email: this.registerData.email,
                });

                if (response.data.exist) {
                    this.errors.email = ["Email já cadastrado"];
                    this.$swal.fire({
                        icon: "error",
                        title: "Este E-mail já está cadastro.",
                        html: '<a href="/login/recover_password">Clique aqui para recuperar a senha</a>',
                        showCancelButton: true,
                        showConfirmButton: false,
                        cancelButtonColor: "red",
                        cancelButtonText: "Fechar",
                    });
                    return;
                }
                this.errors.email = "";
            } catch (e) {}
        },
        restrictInput(event) {
            const allowedKeys = [
                "Backspace",
                "ArrowLeft",
                "ArrowRight",
                "Tab",
                "Delete",
            ];
            const isNumber = /[0-9]/.test(event.key);
            if (!isNumber && !allowedKeys.includes(event.key)) {
                event.preventDefault();
            }
        },
        handlePaste(e) {
            e.preventDefault();
        },
        async submit() {
            this.isLoading = true;

            try {
                const validation = await this.validate();
                if (!validation) return;
                const result = await api.post("v2/register", this.registerData);
                if (result.status === 201) {
                    window.location.href = "/obrigado";
                }
            } catch (e) {
                console.log(e);
                if (e.response.status == 422) {
                    return;
                }
                this.$swal.fire({
                    icon: "error",
                    title: "Ocorreu um erro inesperado",
                    text: e.response.data.message,
                    showConfirmButton: true,
                    confirmButtonText: "Fechar",
                    allowOutsideClick: () => !this.$swal.isLoading(),
                });
            } finally {
                this.isLoading = false;
            }
        },
        async validate() {
            const valid = await schema.safeParseAsync(this.registerData);
            if (!valid.success) {
                this.shouldRevalidate = true;
                this.errors = valid.error.flatten().fieldErrors;
                return false;
            }
            this.errors = {};
            this.shouldRevalidate = false;
            return true;
        },
    },
};
</script>
